import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { SplitText } from "gsapBonus";

export default (function () {
    /**
     * Initialize Slider instances
     */
    $(window).on("load", function () {
        var $selector = $("[data-scroll-tween]");
        var tweens = [];
        gsap.registerPlugin(ScrollTrigger);
        gsap.registerPlugin(SplitText);

        if ($selector.length) {
            if (log) console.log("%cfunction_scroll-tween.js initialized", "color: green;");

            function init() {
                $selector.each(function () {
                    var $instance = $(this);
                    var $trigger = $instance.parents("[data-trigger]").length
                        ? $instance.parents("[data-trigger]")
                        : $instance;
                    var trigger = $trigger.attr("data-trigger");
                    var splitText = $instance.attr("data-split-text")
                        ? JSON.parse((splitText = $instance.attr("data-split-text")))
                        : false;
                    var target = splitText ? new SplitText($instance[0], splitText)[[splitText.target]] : $instance[0];
                    var tween = JSON.parse($instance.attr("data-scroll-tween"));
                    var defaults = { start: "top bottom", end: "bottom top" };
                    var p = trigger ? JSON.parse(trigger) : defaults;

                    tween.to.ease = "none";
                    tween.to.scrollTrigger = {
                        scroller: window,
                        trigger: $trigger[0],
                        start: p.start,
                        end: p.end,
                        scrub: p.scrub ? p.scrub : 1,
                    };

                    tweens.push(gsap.fromTo(target, tween.from, tween.to));
                });
            }

            function clear() {
                tweens.forEach(function (_tween) {
                    _tween.invalidate();
                });
            }

            init();
            /*
            $(window).on("resizeEnd", function () {
                clear();
                init();
            });
            */
        }
    });
})();
